import { i18nTranslate } from 'src/utils'

/**
 * Runs `onEnter` when Enter is pressed on the bound element, suppressing the
 * browser's implicit form submission so the handler stays the only path that
 * fires (otherwise a submit-type button would run the same action twice).
 *
 * @param {Object} options - Options.
 * @param {KeyboardEvent} options.event - The keyboard event.
 * @param {Function} options.onEnter - Handler to run on Enter.
 * @param {boolean} [options.isDisabled=false] - Skip the handler when true.
 */
export const handleEnterKeyPress = ({ event, onEnter, isDisabled = false }) => {
  if (event?.key !== 'Enter') {
    return
  }
  event.preventDefault()
  if (isDisabled) {
    return
  }
  onEnter?.()
}

export const renderFormInput = props => {
  const fieldConfig = [
    [
      {
        name: 'cardCVV',
        labelKey: 'cardCVV',
        type: 'password',
        dataTestId: 'qa-pay-code',
        RenderProps: props.renderCvvNumber(),
        ariaLabel: i18nTranslate('inputs.cvv', 'CVV number input textbox'),
        maxLength: 4,
        columnType: {
          sm: '12',
        },
        placeholderKey: 'cardcvvPlaceHolder',
        customAttributes: {
          autocomplete: 'new-password',
        },
        required: true,
      },
    ],
  ]
  return fieldConfig
}
